var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddIconExp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11091",
    "data-name": "Group 11091",
    transform: "translate(0.032 -0.032)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2863",
    "data-name": "Ellipse 2863",
    cx: 9.949,
    cy: 10,
    rx: 9.949,
    ry: 10,
    transform: "translate(24.562 24.676) rotate(180)",
    fill: "#f2eefb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_34_",
    "data-name": "svgexport-6 (34)",
    transform: "translate(28.968 29.032) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10283",
    "data-name": "Group 10283",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10282",
    "data-name": "Group 10282",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10281",
    "data-name": "Group 10281"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10603",
    "data-name": "Path 10603",
    d: "M0,4.026a.805.805,0,0,0,.805.805H3.221V7.247a.805.805,0,1,0,1.611,0V4.832H7.247a.805.805,0,1,0,0-1.611H4.832V.805a.805.805,0,1,0-1.611,0V3.221H.805A.805.805,0,0,0,0,4.026Z",
    transform: "translate(10.474 10.474)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10604",
    "data-name": "Path 10604",
    d: "M1.114,1.981,2.155,1.55A.805.805,0,1,0,1.539.062L.5.493a.805.805,0,1,0,.616,1.488Z",
    transform: "translate(4.164 11.094) rotate(-45)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10605",
    "data-name": "Path 10605",
    d: "M10.271,0a.8.8,0,0,0,0,1.6A8.651,8.651,0,1,1,1.6,10.268a.8.8,0,0,0-1.6,0A10.253,10.253,0,1,0,10.271,0Z",
    transform: "translate(0 14.5) rotate(-45)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10606",
    "data-name": "Path 10606",
    d: "M1.375,2.172l.8-.8A.805.805,0,0,0,1.033.236l-.8.8A.805.805,0,0,0,1.375,2.172Z",
    transform: "translate(3.398 14.5) rotate(-45)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10607",
    "data-name": "Path 10607",
    d: "M.5,2.591a.805.805,0,0,0,1.052-.436l.431-1.042A.805.805,0,0,0,.493.5L.062,1.539A.805.805,0,0,0,.5,2.591Z",
    transform: "translate(4.163 17.906) rotate(-45)",
    fill: "#7e59d1"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIconExp);
export default __webpack_public_path__ + "static/media/add-icon-exp.31806533f7e8d65579809f16616c9654.svg";
export { ForwardRef as ReactComponent };